import React, { useContext } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import { Box, ThemeProvider } from '@front10/base-elements';
import { EmotionCache } from '../../containers/_commons/emotionCache';
import { Button, Inline, Stack, Text } from '@front10/base-elements';
import { Icon } from '../../../packages/base-elements/Icon/Icon';
import { useTranslation } from '@front10/utils';

/**
 * Atoms
 */
import { FilterButton } from '../../lab/FilterButton';
import { Panels } from '../../containers/VerticalBookingContainer/Panels';
import { FlexibleFilterContainer } from '../../lab/FlexibleFilterContainer';

/**
 * Controls
 */

const styles = {
  grow: {
    flex: 1
  },
  controls: {
    container: {
      borderStyle: 'solid',
      borderWidth: 'default',
      borderRadius: 'default',
      borderColor: 'borders',
      height: '48px'
    },
    button: { display: 'inline-flex', alignItems: 'center', px: '8px' },
    counter: {
      variant: 'text.fontSize5',
      color: 'text',
      alignSelf: 'center',
      width: '30px',
      textAlign: 'center'
    }
  }
};

const PassengerFilter = (props, ref) => {
  const {
    onChange,
    value,
    valueCount,
    count,
    isEventValid,
    disabled,
    filterButtonIconProps,
    doneButtonLabelKey = 'cmp-passenger-filter-done-button',
    titleKey = 'cmp-passenger-filter-title',
    popover = {},
    options = [
      {
        name: 'passenger1',
        label: 'passenger1-key',
        description: 'passenger1-desc-key',
        enabled: true
      },
      {
        name: 'passenger2',
        label: 'passenger2-key',
        description: 'passenger2-desc-key',
        enabled: true
      },
      {
        name: 'passenger3',
        label: 'passenger3-key',
        description: 'passenger3-desc-key',
        enabled: true
      }
    ],
    optionGap = '20px',
    dispatch
  } = props;

  const flexibleRef = React.useRef();

  const {
    direction,
    theme: { designTokens }
  } = useContext(Context);

  const translate = useTranslation();

  const update = React.useCallback(() => {
    return dispatch({
      type: 'VALUE_SET',
      value: {
        ...valueCount
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueCount]);

  const save = () => {
    onChange(value);
  };

  var timer;
  return (
    <EmotionCache direction={direction}>
      <ThemeProvider theme={designTokens}>
        <FlexibleFilterContainer
          ref={flexibleRef}
          showSeparator
          saveOnClose={false}
          variant="layout.popover"
          label={translate(titleKey, 'passangers')}
          title={translate(titleKey, 'Passangers info')}
          // disabledDoneButton={disabledButton}
          enabledDoneButton
          labelBottomBtn={translate(doneButtonLabelKey, 'Done')}
          onDismiss={() => {
            update();
          }}
          onOpenPopup={() => {
            update();
          }}
          toggleElement={
            <FilterButton
              iconSettings={filterButtonIconProps}
              value={`${count} ${translate(titleKey, 'Passenger')}`}
              disabled={disabled} // used to disabled the component
              active={true}
              onFocus={() => {
                if (flexibleRef.current.isOpen) {
                  timer = setTimeout(() => {
                    flexibleRef.current?.close();
                  }, 150);
                }
              }}
              onBlur={() => {
                clearTimeout(timer);
              }}
            />
          }
          onSave={() => save()}
          {...popover}
        >
          <Panels showSeparator={false}>
            <>
              <Box style={{ paddingBottom: '20px' }}>
                <Text variant="fontSize4" color="text">
                  {translate('cmp-passenger-filter-passengers', 'Passengers')}
                </Text>
              </Box>
              {options.map((option, index) => {
                const addEvent = { index, type: 'ADD' };
                const removeEvent = { index, type: 'REMOVE' };
                const label = translate(`cmp-passenger-filter-${option.label}`, option.name);
                return (
                  option.enabled && (
                    <Inline
                      alignY="center"
                      align="start"
                      gap={optionGap}
                      sx={styles.grow}
                      childrenBottomMargin
                    >
                      <Stack gap={1} sx={styles.grow}>
                        <Text variant="fontSize5" color="text">
                          {label}
                        </Text>
                        <Text variant="fontSize7" color="text">
                          {translate(`cmp-passenger-filter-${option.description}`, 'description')}
                        </Text>
                      </Stack>
                      <Inline
                        sx={styles.controls.container}
                        variant="forms.spinButton"
                        data-disabled={
                          isEventValid
                            ? !isEventValid(addEvent, value) && !isEventValid(removeEvent, value)
                            : false
                        }
                      >
                        <Button
                          variant="text"
                          aria-label={translate(
                            'cmp-passenger-filter-remove-btn-label',
                            'Decrease {label}',
                            {
                              label
                            }
                          )}
                          onClick={() => dispatch(removeEvent)}
                          sx={styles.controls.button}
                          disabled={isEventValid ? !isEventValid(removeEvent, value) : false}
                        >
                          <Icon aria-hidden={true} size={20} icon="remove" />
                        </Button>
                        <Text aria-live="polite" as="span" sx={styles.controls.counter}>
                          {value.count[index]}
                        </Text>
                        <Button
                          variant="text"
                          aria-label={translate(
                            'cmp-passenger-filter-add-btn-label',
                            'Increase {label}',
                            {
                              label
                            }
                          )}
                          onClick={() => dispatch(addEvent)}
                          sx={styles.controls.button}
                          disabled={isEventValid ? !isEventValid(addEvent, value) : false}
                        >
                          <Icon aria-hidden={true} size={20} icon="add" />
                        </Button>
                      </Inline>
                    </Inline>
                  )
                );
              })}
            </>
          </Panels>
        </FlexibleFilterContainer>
      </ThemeProvider>
    </EmotionCache>
  );
};

export default React.forwardRef(PassengerFilter);
